const PRECISE_DOSAGE_PORTION_MIN_VALUE = 0.25;
const PRECISE_DOSAGE_PORTION_MAX_VALUE = 9999.99;
const PRECISE_DOSAGE_PORTION_STEP = 0.5;
const PRECISE_DOSAGE_PORTION_PRECISION = 2;

export const getPreciseDosagePortionMinValue = (): number => {
   return PRECISE_DOSAGE_PORTION_MIN_VALUE;
};

export const getPreciseDosagePortionMaxValue = (): number => {
   return PRECISE_DOSAGE_PORTION_MAX_VALUE;
};

export const getPreciseDosagePortionStep = (): number => {
   return PRECISE_DOSAGE_PORTION_STEP;
};

export const getPreciseDosagePortionPrecision = (): number => {
   return PRECISE_DOSAGE_PORTION_PRECISION;
};

const ONE_THIRD_QUANTITY = 0.33333;
const TWO_THIRDS_QUANTITY = 0.66666;
const FRACTION_DECIMAL_PLACES = 2;
const P1_QUANTITY_DECIMAL_PLACES = 5;

// eslint-disable-next-line @typescript-eslint/no-magic-numbers
const ONE_THIRD_INPUTS = [0.33, 0.34];
// eslint-disable-next-line @typescript-eslint/no-magic-numbers
const TWO_THIRDS_INPUTS = [0.66, 0.67];

export const getP1DosagePortion = (portion: number): number => {
   const wholePart = Math.floor(portion);
   const fraction = Number((portion - wholePart).toFixed(FRACTION_DECIMAL_PLACES));

   if (ONE_THIRD_INPUTS.includes(fraction)) {
      return Number((wholePart + ONE_THIRD_QUANTITY).toFixed(P1_QUANTITY_DECIMAL_PLACES));
   }

   if (TWO_THIRDS_INPUTS.includes(fraction)) {
      return Number((wholePart + TWO_THIRDS_QUANTITY).toFixed(P1_QUANTITY_DECIMAL_PLACES));
   }

   return portion;
};
